import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles from "component/utils/DatatableStyles";

const paginationOptions = {
  rowsPerPageText: "Show Per Page:",
  rangeSeparatorText: "dari",
};

const GroupAccountTable = ({ data }) => {
  const [search, setSearch] = useState("");

  // Tambahkan ID otomatis
  const formattedData = data.map((item, index) => ({
    id: index + 1,
    ...item,
  }));

  // Filter berdasarkan semua kolom terkait
  const filteredData = formattedData.filter((item) =>
    [
      item?.group_account_code,
      item?.group_account_desc,
      item?.group_account_dep,
      item?.group_account_div,
      item?.group_account_table,
    ].some((field) =>
      field?.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  const columns = [
    {
      name: "No",
      selector: (row) => row.id,
      minWidth: "70px",
      maxWidth: "100px",
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      sortable: true,
    },
    {
      name: "Zona Code",
      selector: (row) => row.group_account_code,
      sortable: true,
      grow: 2,
      maxWidth: "120px",
      style: { display: "flex", justifyContent: "center", alignItems: "center" },
    },
    {
      name: "Zona Desc",
      selector: (row) => row.group_account_desc,
      sortable: true,
      grow: 3,
      wrap: true,
      maxWidth: "450px",
    },
    {
      name: "Dep Group",
      selector: (row) => row.group_account_dep,
      sortable: true,
      grow: 2,
      maxWidth: "150px",
    },
    {
      name: "Div Group",
      selector: (row) => row.group_account_div,
      sortable: true,
      grow: 2,
      maxWidth: "150px",
    },
    {
      name: "Table Group",
      selector: (row) => row.group_account_table,
      sortable: true,
      grow: 2,
      maxWidth: "150px",
    },
  ];

  return (
    <div className="col-lg-12 mb-4">
      <div className="d-flex justify-content-start align-items-center mb-2">
        <input
          type="text"
          placeholder="Search..."
          className="form-control w-100"
          style={{ maxWidth: "200px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="datatable-container">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          customStyles={DatatableStyles}
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 25]}
          paginationComponentOptions={paginationOptions}
          responsive
        />
      </div>
    </div>
  );
};

export default GroupAccountTable;
